import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SalesReportsResponse } from '../models/sales-reports.models';
import { SalesReportsApiService } from './sales-reports-api.service';
import { ApiResponse } from '../../../companies/data/models/company.models';

@Injectable({
  providedIn: 'root'
})
export class SalesReportsService {
  private salesReportsApiService = inject(SalesReportsApiService);

  getSalesReports(params: any): Observable<ApiResponse<SalesReportsResponse>> {
    return this.salesReportsApiService.getSalesReports(params);
  }
}